const form = {
	display_name: {
		helper: "Geben Sie Ihrem daDup-Konto einen Anzeigenamen.",
		label: "Anzeigename",
		placeholder: "Bucket_Holder_01",
		placeholder_example: "Zum Beispiel: Bucket_Holder_01",
	},
};

export default form;
